import { Component, OnInit } from '@angular/core';
import { Setting } from 'src/app/modules/entities/setting';
import { SettingService } from 'src/app/modules/services/setting.service';

@Component({
  selector: 'app-allies',
  templateUrl: './allies.component.html',
  styleUrls: ['./allies.component.css']
})
export class AlliesComponent implements OnInit {

  constructor(private settingService: SettingService) {  }

  allies: string[] = [];
  allyBanners: {[key: string]: string} = {};

  ngOnInit(): void {
    this.settingService.getSettingLikeName('ally').subscribe({
      next: response => {
        if (response.status === 'success') {
          let settings = response.data as Setting[];
          for (let setting of settings) {
            let ally = String(setting.value).split('|')[0];
            this.allies.push(ally);
            this.allyBanners[ally] = (String(setting.value).split('|')[1]);
          }
        }
      }
    });
  }

}
